import { Mission } from '../../store/missions/types';

export enum ProductType {
    Meeting = 'meeting',
    Course = 'course',
    Article = 'article',
    Video = 'video',
}

export interface ProductsProps {
    missions: Mission[];
}

export interface Product {
    title: string;
    id: string;
    paid?: boolean;
    price?: number;
}

export interface StateProduct {
    title: string;
    id: string;
    paid?: boolean;
    price?: string;
}
